/**
 * Available roles as configured in Keycloak realm settings
 */
export const ROLES = {
  USER: 'MUser',
  ADMIN: 'MAdmin',
};
